module.exports = __webpack_public_path__ + "media/images/logo-e633d87bd1d5ed59f2cee2240b87b6f1.png";